export default __webpack_public_path__ + "static/media/qr-code_paper_jam.5db8c3ca.png";